/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerProvisionalDetailConfig } from '../../config/header.config';

export interface IHeaderProvisionalDetailPluginMethods
  extends IPluginMethodMap {
  getHeaderProvisionalDetailSync(args?: any): any;
}

export class HeaderProvisionalDetailPlugin implements IAgentPlugin {
  readonly methods: IHeaderProvisionalDetailPluginMethods;

  constructor() {
    this.methods = {
      getHeaderProvisionalDetailSync:
        this.getHeaderProvisionalDetailSync.bind(this),
    };
  }

  getHeaderProvisionalDetailSync(args?: any) {
    return {
      header: headerProvisionalDetailConfig,
    };
  }
}
